import type { KYCStatus } from '@/types/kyc';
import { useKYCStore } from '@/stores';
import { useToast } from 'primevue/usetoast';
import { ref, computed } from 'vue';
import { mainDomain } from '@/utils/variables';
import { usePlayer } from './usePlayer';
export function useKYC() {
    const { isPlayer } = usePlayer();
    const kycStore = useKYCStore();
    const toast = useToast();
    const loadingFlag = computed<boolean>(() => kycStore.loadingFlag);
    const localLoadingFlag = ref<boolean>(false);
    const kycStatus = computed<KYCStatus>(() => kycStore.kyc);
    const isTMB = computed(() => {
        return mainDomain.includes('takemybet');
    });
    const isNeedVerification = computed<boolean>(() => kycStatus.value.required.length > 0 && !!kycStatus.value.kyc_user_prompt_stage?.['tunduk-faceid'] && isPlayer.value);
    const toastGetKYCStatus = 'get_kyc_status';
    const toastUploadPhoto = 'upload_photo';
    async function toGetKYCStatus() {
        localLoadingFlag.value = true;
        try {
            await kycStore.awaitGetKYCStatus();
        } catch (error) {
            toast.add({ severity: 'error', group: 'global', summary: toastGetKYCStatus, detail: error, life: 4000 });
        } finally {
            localLoadingFlag.value = false;
        }
    }
    async function toUploadPhoto(photo: string) {
        localLoadingFlag.value = true;
        try {
            await kycStore.awaitUploadPhoto(photo);
        } catch (error) {
            if (error instanceof Error) {
                if (!error.cause) {
                    toast.add({ severity: 'error', group: 'global', summary: toastUploadPhoto, detail: error.message, life: 4000 });
                }
            }
            throw error;
        } finally {
            localLoadingFlag.value = false;
        }
    }
    return {
        localLoadingFlag,
        loadingFlag,
        kycStatus,
        toGetKYCStatus,
        toUploadPhoto,
        isNeedVerification,
        isTMB
    };
}
